<template>
  <div class="app flex-row align-items-center background-image">
    <div class="container">
      <div v-if="showingPopup" class="popup-overlay">
        <div class="popup">
          <p>{{ popupMessage }}</p>
          <button @click="handlePopupClose" class="btn-close">
            Fechar
          </button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 text-center" style="padding-bottom: 50px;">
          <img src="favicon.png" class="centered-image" alt="Logo Inpar" />
        </div>
      </div>
      <div class="row justify-content-center mt-4">
        <div class="col-md-4">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <form v-if="!isResetForm" @submit.prevent="requestResetLink">
                  <h3>{{ appName }}</h3>
                  <p class="text-muted">Para recuperar a sua palavra-passe, insira o seu e-mail abaixo.</p>
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-text slot="prepend">
                        <i class="fa fa-envelope"></i>
                      </b-input-group-text>
                      <b-form-input type="email" name="email" placeholder="E-mail" v-model="email" required />
                    </b-input-group>
                  </b-form-group>
                  <div class="row">
                    <div class="col-12 text-center">
                      <button :disabled="working" type="submit" class="btn btn-primary btn-block">Enviar</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      showingPopup: false,
      popupMessage: '',
      appName: 'Inpar',
      email: '',
      working: false,
      redirectToLogin: false,
      isResetForm:false,
    };
  },
  methods: {
    async requestResetLink() {
      this.working = true;
      try {
        const response = await axios.post('/auth/sendreset', {
          email: this.email
        });
        this.showPopup(response.data.message);
        this.redirectToLogin = true;  // Sinaliza para redirecionar após o sucesso
      } 
      catch (error) {
       if (error.response && error.response.status === 422) {
      this.showPopup('Este email ainda não está registado no nosso sistema.');
    } 
    else { this.showPopup('Erro ao enviar o link de reset.');
       }
        this.redirectToLogin = false;
      } finally {
        this.working = false;
      }
    },
    showPopup(message) {
      this.popupMessage = message;
      this.showingPopup = true;
    },
    handlePopupClose() {
      this.showingPopup = false;
      if (this.redirectToLogin) {
        this.$router.push({ name: 'login' });
      }
    }
  }
};
</script>

<style>
.background-image {
  background-color: #fce9d7;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100vh;
}

.text-right {
  text-align: center !important;
}

.btn-block {
  width: 100%;
}

.btn-primary {
  color: #fff;
  background-color: #ff5a00;
  border-color: #ff5a00;
}

.btn-primary:hover {
  color: #fff;
  background-color: #cd4800;
  border-color: #cd4800;
}

.btn-primary:disabled {
  color: #fff;
  background-color: #cd4800;
  border-color: #cd4800;
}

.centered-image {
  max-width: 125px;
  height: auto;
}

/* Pop-up overlay and styling */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  max-width: 80%;
  text-align: center;
}

.popup p {
  color: rgb(0, 0, 0);
  margin-bottom: 20px;
}

.btn-close {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-close:hover {
  background-color: #e96d2f;
}
</style>